import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

export enum OutgoingTime {
  Morning = 1,
  MidLateMorning,
  LateMorning,
  Afternoon,
  WholeDay,
}

export enum IncomingTime {
  Morning = 10,
  EarlyAfternoon,
  MidAfternoon,
  Afternoon,
  WholeDay,
}

function getPlaceHolderOutgoing(value: OutgoingTime) {
  const options = {
    [OutgoingTime.Morning]: '07:00 - 14:00',
    [OutgoingTime.MidLateMorning]: '07:00 - 15:00',
    [OutgoingTime.LateMorning]: '07:00 - 16:00',
    [OutgoingTime.Afternoon]: '14:00 - 20:00',
    [OutgoingTime.WholeDay]: '07:00 - 20:00',
  }
  return options[value] || 'Not in enum'
}

function getPlaceHolderIncoming(value: IncomingTime) {
  const options = {
    [IncomingTime.Morning]: '10:00 - 16:00',
    [IncomingTime.EarlyAfternoon]: '13:00 - 22:00',
    [IncomingTime.MidAfternoon]: '14:00 - 22:00',
    [IncomingTime.Afternoon]: '16:00 - 22:00',
    [IncomingTime.WholeDay]: '10:00 - 22:00',
  }
  return options[value] || 'Not in enum'
}

export function getValueForOutgoingTime(time: OutgoingTime): string {
  const options = {
    [OutgoingTime.Morning]: '07-14',
    [OutgoingTime.MidLateMorning]: '07-15',
    [OutgoingTime.LateMorning]: '07-16',
    [OutgoingTime.Afternoon]: '14-20',
    [OutgoingTime.WholeDay]: '07-20',
  }
  return options[time] || '07-20'
}

export function getValueForIncomingTime(time: IncomingTime): string {
  const options = {
    [IncomingTime.Morning]: '10-16',
    [IncomingTime.Afternoon]: '16-22',
    [IncomingTime.EarlyAfternoon]: '13-22',
    [IncomingTime.MidAfternoon]: '14-22',
    [IncomingTime.WholeDay]: '10-22',
  }
  return options[time] || '10-22'
}

export function getOutgoing(value: OutgoingTime) {
  return (
    <DisplayContent
      edit={true}
      addNode={false}
      contentKey={`outgoingTime-${OutgoingTime[value]}`}
    >
      {getPlaceHolderOutgoing(value)}
    </DisplayContent>
  )
}

export function getIncoming(value: IncomingTime) {
  return (
    <DisplayContent
      edit={true}
      addNode={false}
      contentKey={`incomingTime-${OutgoingTime[value]}`}
    >
      {getPlaceHolderIncoming(value)}
    </DisplayContent>
  )
}
